"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const fetchDataFromDOM = () => {
  try {
    const DOMData = document.querySelector("template[is=\"mco-dom-data\"]");
    if (!DOMData) return null;
    const JSONData = JSON.parse(DOMData.content.textContent);
    DOMData.remove();
    return JSONData;
  } catch (error) {
    return null;
  }
};
var _default = exports.default = fetchDataFromDOM;